import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { StateProvider } from './ContextApi/StateProvider';
import reducer, { initialState } from './ContextApi/Reducer';

const mountApp = document.getElementById('root');
const root = createRoot(mountApp);

root.render(
  <React.StrictMode>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
    </StateProvider>
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'development') {
  module.hot.accept();
}
